import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import { getServiceBySlug } from './serviceData';
import DestinationGrid from './DestinationGrid';
import './ServiceDetail.css';

function ServiceDetail({ serviceSlug }) {
  const { slug: routeSlug } = useParams();
  const slug = serviceSlug || routeSlug;
  const service = getServiceBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!service) return <Navigate to="/services" replace />;

  return (
    <div className="service-detail-page">
      <Navbar />
      <header className="service-detail-hero">
        <img src={service.image} alt={service.name} />
        <div className="service-detail-shade" />
        <div className="service-detail-hero-content">
          <Link to="/services" className="service-detail-back">← All services</Link>
          <h1>{service.name}</h1>
        </div>
      </header>

      <main className="service-detail-main">
        <section className="service-detail-copy">
          <span className="service-detail-kicker">About this service</span>
          <h2>How we can help</h2>
          <p>{service.intro}</p>
          {service.additionalIntro && <p>{service.additionalIntro}</p>}
          {/* {service.supplierLink && (
            <a className="service-detail-supplier" href={service.supplierLink.href}>
              {service.supplierLink.image ? (
                <img src={service.supplierLink.image} alt={service.supplierLink.imageAlt} />
              ) : service.supplierLink.label}
            </a>
          )} */}
          {service.testimonial && (
            <blockquote className="service-detail-testimonial">
              {service.testimonial.quote.split('\n\n').map((paragraph, index, paragraphs) => (
                <p key={paragraph}>{index === 0 && '“'}{paragraph}{index === paragraphs.length - 1 && '”'}</p>
              ))}
              {(service.testimonial.attribution || service.testimonial.company || service.testimonial.author) && (
                <footer>— {service.testimonial.attribution || [service.testimonial.company, service.testimonial.author].filter(Boolean).join(', ')}</footer>
              )}
            </blockquote>
          )}
        </section>
        <aside className="service-detail-list">
          <h2>Key capabilities</h2>
          <ul>{service.highlights.map((item) => <li key={item}>{item}</li>)}</ul>
        </aside>
      </main>

      {service.gallery && (
        <section className="service-detail-gallery" aria-label={`${service.name} gallery`}>
          {service.gallery.map((image) => (
            <img key={image.src} src={image.src} alt={image.alt} loading="lazy" />
          ))}
        </section>
      )}

      {slug === 'destination-itineraries-caribbean-support' && <DestinationGrid />}

      <section className="service-detail-cta">
        <div><span>Need assistance?</span><h2>Contact us to discuss your requirements.</h2></div>
        <div className="service-detail-actions">
          <Link to="/contact" className="service-detail-primary">Contact Us</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ServiceDetail;
